/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonetaryBreakdown } from './MonetaryBreakdown';
import {
    MonetaryBreakdownFromJSON,
    MonetaryBreakdownFromJSONTyped,
    MonetaryBreakdownToJSON,
    MonetaryBreakdownToJSONTyped,
} from './MonetaryBreakdown';
import type { IndividualConsequence } from './IndividualConsequence';
import {
    IndividualConsequenceFromJSON,
    IndividualConsequenceFromJSONTyped,
    IndividualConsequenceToJSON,
    IndividualConsequenceToJSONTyped,
} from './IndividualConsequence';

/**
 * 
 * @export
 * @interface Outcome
 */
export interface Outcome {
    /**
     * 
     * @type {number}
     * @memberof Outcome
     */
    monetaryPenalty?: number | null;
    /**
     * 
     * @type {MonetaryBreakdown}
     * @memberof Outcome
     */
    breakdown?: MonetaryBreakdown | null;
    /**
     * List of individual consequences that were imposed
     * @type {Array<IndividualConsequence>}
     * @memberof Outcome
     */
    individualConsequences?: Array<IndividualConsequence>;
    /**
     * List of non-monetary remedies that were imposed
     * @type {Array<string>}
     * @memberof Outcome
     */
    nonMonetaryRemedies?: Array<string>;
}

/**
 * Check if a given object implements the Outcome interface.
 */
export function instanceOfOutcome(value: object): value is Outcome {
    return true;
}

export function OutcomeFromJSON(json: any): Outcome {
    return OutcomeFromJSONTyped(json, false);
}

export function OutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Outcome {
    if (json == null) {
        return json;
    }
    return {
        
        'monetaryPenalty': json['monetary_penalty'] == null ? undefined : json['monetary_penalty'],
        'breakdown': json['breakdown'] == null ? undefined : MonetaryBreakdownFromJSON(json['breakdown']),
        'individualConsequences': json['individual_consequences'] == null ? undefined : ((json['individual_consequences'] as Array<any>).map(IndividualConsequenceFromJSON)),
        'nonMonetaryRemedies': json['non_monetary_remedies'] == null ? undefined : json['non_monetary_remedies'],
    };
}

export function OutcomeToJSON(json: any): Outcome {
    return OutcomeToJSONTyped(json, false);
}

export function OutcomeToJSONTyped(value?: Outcome | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monetary_penalty': value['monetaryPenalty'],
        'breakdown': MonetaryBreakdownToJSON(value['breakdown']),
        'individual_consequences': value['individualConsequences'] == null ? undefined : ((value['individualConsequences'] as Array<any>).map(IndividualConsequenceToJSON)),
        'non_monetary_remedies': value['nonMonetaryRemedies'],
    };
}

